import React from 'react';
import { MathLiveEditor as PackageMathLiveEditor } from '@huoncroll/math-editors';

type Props = {
  value: string;
  onChange: (latex: string) => void;
  minWidthPx?: number;
  minWidthPercent?: number;
  minHeightPx?: number;
  maxHeightPx?: number;
};

const SharedMathLiveEditor = PackageMathLiveEditor as unknown as React.ComponentType<Props>;

export default SharedMathLiveEditor;
